import React from 'react';
import { theme } from '../theme';

const TABS = ['Identity', 'Direction', 'Vibe', 'Commitment'];

function SplitLayout({ rightContent, leftTitle, currentTab, subtitle, greeting, titleExtra }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(180deg, ${theme.colors.gradientTop} 0%, ${theme.colors.gradientBottom} 100%)`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '20px var(--app-padding, 16px) 80px',
    }}>
      <div style={{
        width: '100%',
        maxWidth: 'var(--app-max-width, 100%)',
        animation: 'fadeIn 0.4s ease',
      }}>
        {/* Tab Header */}
        {currentTab !== undefined && (
          <div style={{
            display: 'flex',
            gap: '8px',
            marginBottom: '24px',
            flexWrap: 'wrap',
          }}>
            {TABS.map((tab, i) => (
              <span key={tab} style={{
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: i === currentTab ? '600' : '400',
                backgroundColor: i === currentTab ? theme.colors.surfaceWhite : 'transparent',
                color: i === currentTab ? theme.colors.textDark : 'rgba(255,255,255,0.7)',
                transition: 'all 0.3s ease',
              }}>{tab}</span>
            ))}
          </div>
        )}

        {/* Greeting */}
        {greeting && (
          <p style={{
            fontSize: '15px',
            color: theme.colors.textDark,
            marginBottom: '2px',
            fontWeight: '400',
          }}>{greeting}</p>
        )}

        {/* Title */}
        {leftTitle && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: subtitle ? '4px' : '20px',
          }}>
            <h1 style={{
              fontSize: '26px',
              fontWeight: '600',
              color: theme.colors.textDark,
              lineHeight: '1.3',
              margin: 0,
            }}>{leftTitle}</h1>
            {titleExtra}
          </div>
        )}

        {subtitle && (
          <p style={{
            fontSize: '14px',
            color: theme.colors.textMedium,
            marginBottom: '20px',
            lineHeight: '1.4',
          }}>{subtitle}</p>
        )}

        {/* Content Card */}
        <div style={{
          backgroundColor: theme.colors.surfaceCard,
          borderRadius: theme.borderRadius.card,
          padding: '28px 24px',
          backdropFilter: 'blur(10px)',
        }}>
          {rightContent}
        </div>
      </div>
    </div>
  );
}

export default SplitLayout;
